// extracted by mini-css-extract-plugin
export default {"container":"FindDiagnosisResult_container__xGHfr","text":"FindDiagnosisResult_text__Thcdi","submit":"FindDiagnosisResult_submit__SJWUU"};